import React from "react";
import { PrimaryBtn } from "../../../components";
import { FaHome } from "react-icons/fa";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full h-screen md:flex-row">
      <h1 className="text-[8rem] font-bold text-rose-700">404</h1>
      <div className="w-24 h-1 my-6 md:w-1 md:h-24 bg-rose-700 md:my-0 md:mx-8"></div>
      <div className="flex flex-col items-center">
        <h2 className="mb-4 text-2xl text-center">
          Maaf, halaman ini tidak tersedia !
        </h2>
        <Link
          to="/"
          className="block w-full rounded bg-rose-600 px-12 py-3 text-sm font-medium text-white shadow hover:bg-rose-700 focus:outline-none focus:ring active:bg-rose-500 sm:w-auto"
        >Kembali ke Beranda
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
